export default __webpack_public_path__ + "static/media/SRI_180Days.3618593c.webm";